export default __webpack_public_path__ + "static/media/project_visual_15.b18a0831.jpg";